import "core-js/modules/es.number.constructor";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.split";
import { computed, defineComponent } from '@vue/composition-api';
import { cashFormat } from '@/common/util';
export default defineComponent({
  name: '',
  components: {},
  props: {
    discountPrice: {
      // 已砍金额
      type: Number,
      default: 0
    },
    restPrice: {
      // 剩余金额
      type: Number,
      default: 0
    }
  },
  setup: function setup(props, ctx) {
    var k18nList = [ctx.root.$k18n({
      text: '{0} were haggled, only {1} remains'
    }), ctx.root.$k18n({
      text: '{0} were haggled, only {1} remains',
      desc: '都单数'
    }), ctx.root.$k18n({
      text: '{0} were haggled, only {1} remains',
      desc: '已砍价格单数，剩余价格复数'
    }), ctx.root.$k18n({
      text: '{0} were haggled, only {1} remains',
      desc: '已砍价格复数，剩余价格单数'
    })];
    var textSplit = computed(function () {
      var discountPrice = props.discountPrice,
          restPrice = props.restPrice;

      var _discountPrice = discountPrice / 100;

      var _restPrice = restPrice / 100;

      var k18nText = _discountPrice < 2 && _restPrice < 2 ? k18nList[1] : _discountPrice < 2 && _restPrice >= 2 ? k18nList[2] : _discountPrice >= 2 && _restPrice < 2 ? k18nList[3] : k18nList[0];
      return k18nText.split(/\{([0-9])\}/);
    });
    return {
      textSplit: textSplit,
      cashFormat: cashFormat
    };
  }
});